<div class="container-fluid" [class.px-0]="noPadding">
  <div class="row">
    <div class="col-12 text-center">
      <div class="pull-left">
        <ngb-pagination [collectionSize]="totalRecords" [(page)]="pagination.page" [pageSize]="pagination.pagesize"
                        [directionLinks]="pagination.directionLinks" [maxSize]="pagination.maxPaginationItems"
                        [boundaryLinks]="pagination.boundaryLinks" [ellipses]="pagination.ellipses"
                        [rotate]="pagination.rotate" [size]="pagination.size" (pageChange)="emitPageChange()"></ngb-pagination>
      </div>
      <div class="pull-right d-flex">
        <span class="pe-3 align-self-center text-uppercase">{{"HEADER.VIEW" | translate}}</span>
        <div class="pull-right w-auto">
          <ng-select
                  [clearable]="false"
                  [searchable]="false"
                  [items]="pagination.allowedRanges"
                  [disabled]="!(totalRecords > 0)"
                  bindLabel="range"
                  bindValue="range"
                  [placeholder]="'-'"
                  (change)="emitRecordsPerPageChange()"
                  class="width-page-results"
                  [(ngModel)]="pagination.pagesize">
          </ng-select>
        </div>
      </div>
    </div>
  </div>
</div>
